/* eslint-disable-next-line no-restricted-imports */
import { countryLanguageConfig } from '../../translations/config';

export const getTermsAndConditionsForCountry = (termsAndConditions, merchantCountryKey) => {
  const countryToC = termsAndConditions.find(
    ({ country, language }) =>
      (country && country === merchantCountryKey) ||
      (language && language === countryLanguageConfig[merchantCountryKey]),
  );

  if (countryToC) {
    return countryToC;
  }

  return termsAndConditions.find(
    ({ country, language }) => country === 'default' || language === 'en',
  );
};
